import {gql} from "@apollo/client";
import Tools from "../../../../Tools";
import dustinWilliamsonAvatar from "../../../../assets/img/demo/dustin-williamson-avatar.png";

/**
 * @param regionId {string} The region id.
 * @type {{getCountryByRegion: Array}} Array of countries.
 */
export const talentSearchQueries = {
    getCountriesByRegionsId: gql`
        query getCountries ($regionsIds: [String!]) {
            countries: getCountries(regions: $regionsIds){
                id
                name
            }
        }
    `,

    getRegions: gql`
        {
            regions: getRegions{
                id
                name
            }
        }
    `,
};
